import { LoginFlowProvider } from 'feature/login-flow/use-login-flow';
import { PATH } from 'config';
import { ReceiptProvider } from 'feature/receipt/use-receipt';
import { StreetParkingProvider } from 'feature/street-parking/use-street-parking';
import { LicensePlatesProvider } from 'feature/license-plates/use-license-plate';
import { MochipayFlowProvider } from 'feature/mochi-pay-flow/use-mochi-pay-flow';
import Expired from './feature/expired';

const Routing = [
  { path: PATH.MAIN, component: Expired },
  { path: PATH.MAPS, component: Expired },
  { path: PATH.COINS, component: Expired },
  { path: PATH.PROFILE_SETTING, component: Expired },
  { path: PATH.SETTINGS, component: Expired },
  { path: PATH.ORDERS, component: Expired },
  { path: PATH.ORDER_DETAIL, component: Expired },
  { path: PATH.SERVICE_INSTRUCTION, component: Expired },
  { path: PATH.EXPIRED, component: Expired },
  { path: PATH.CONTACT, component: Expired },
  {
    path: PATH.USER_INDEX,
    provider: LoginFlowProvider,
    routes: [
      { path: PATH.USER_WELCOME, component: Expired },
      { path: PATH.USER_ENABLE_ON_STREET_PARKING_AUTO_PAY, component: Expired },
      { path: PATH.USER_ACTIVATE_PLATE_NUMBER, component: Expired },
      { path: PATH.USER_BIND_CARD, component: Expired },
      { path: PATH.USER_ON_STREET_PARKING_AUTO_PAY_NOTICE, component: Expired },
    ],
  },
  {
    path: PATH.PATH_RECEIPT_INDEX,
    provider: ReceiptProvider,
    routes: [
      { path: PATH.RECEIPT_INDEX, component: Expired },
      { path: PATH.RECEIPT_DONATE, component: Expired },
    ],
  },
  {
    path: PATH.STREET_PARKING_INDEX,
    provider: StreetParkingProvider,
    routes: [
      { path: PATH.STREET_PARKING_AUTOPAY, component: Expired },
      { path: PATH.STREET_PARKING_CITIES, component: Expired },
      { path: PATH.STREET_PARKING_PLATES, component: Expired },
      { path: PATH.STREET_PARKING_BILLS, component: Expired },
    ],
  },
  {
    path: PATH.LICENSE_PLATES_INDEX,
    provider: LicensePlatesProvider,
    routes: [{ path: PATH.LICENSE_PLATES_INDEX, component: Expired }],
  },
  {
    path: PATH.MOCHIPAY_FLOW_INDEX,
    provider: MochipayFlowProvider,
    routes: [
      { path: PATH.MOCHIPAY_FLOW_SETTING, component: Expired },
      { path: PATH.MOCHIPAY_FLOW_CREDIT_CARD, component: Expired },
    ],
  },
];

export default Routing;
